const initialState = {
    open: [], 
    close:[],
    appointments:[],
    
    
  
  };
  
  const PatientHistoryReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA1_SUCCESS':
            return {... state, open:action.payload};
            case 'FETCH_DATA2_SUCCESS':
            return {... state, close:action.payload};
            case 'FETCH_DATA3_SUCCESS':
            return {... state, appointments:action.payload};
           
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default PatientHistoryReducers;
  
  